import { IconProps } from "../../utils/global-types/global-types";

const MarketingIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <g clipPath="url(#clip0_4130_53506)">
      <g fill="currentColor" clipPath="url(#clip1_4130_53506)">
        <path d="m15.596 7.644-6.24-6.242a.94.94 0 0 0-1.327 0 .94.94 0 0 0 0 1.326l6.242 6.241a.938.938 0 0 0 1.325-1.325M7.566 3.591l-.047.236c-.33 1.655-1.135 3.227-2.222 4.501l3.395 3.395c1.274-1.087 2.825-1.913 4.48-2.244l.236-.047zM4.674 9.031l-2.32 2.32a1.406 1.406 0 0 0 0 1.99l1.326 1.325c.548.548 1.438.55 1.989 0l2.32-2.32zm.332 3.646a.469.469 0 1 1-.663-.662l.663-.663a.469.469 0 1 1 .663.663zM9.946 14.915l.638-.637c.55-.55.548-1.44 0-1.989l-.474-.474a9 9 0 0 0-.755.571l.566.567a.47.47 0 0 1 0 .662l-.649.648-.952-.923-1.326 1.326 2.127 2.06a.938.938 0 0 0 1.325-1.326zM11.84 1a.47.47 0 0 0-.469.47v.937a.469.469 0 1 0 .938 0v-.938c0-.259-.21-.469-.47-.469M15.59 4.75h-.938a.469.469 0 1 0 0 .938h.937a.468.468 0 1 0 0-.938M14.983 2.075a.47.47 0 0 0-.663 0l-.937.938a.469.469 0 1 0 .663.663l.937-.938a.47.47 0 0 0 0-.663"></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4130_53506">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
      <clipPath id="clip1_4130_53506">
        <path fill="#fff" d="M1 1h16v16H1z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default MarketingIcon;
